import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=bbfc0108&scoped=true&"
import script from "./Appeals.vue?vue&type=script&lang=js&"
export * from "./Appeals.vue?vue&type=script&lang=js&"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=bbfc0108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc0108",
  null
  
)

export default component.exports